import { render } from "./comment-input.vue?vue&type=template&id=91c6c9b6&ts=true"
import script from "./comment-input.vue?vue&type=script&lang=ts"
export * from "./comment-input.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__